module.exports = __webpack_public_path__ + "media/Elzbieta_Radziwill.511d94f4.mp4";